import React from 'react'
import { UseFormRegisterReturn, FieldName, FieldValues } from 'react-hook-form'
import { Radio } from './styles'
import { message } from '~/services'
import { LabelForm } from '~/components/shared'
import { Inline, Stack } from '~/styles'
import { EFeedbackType } from '~/interfaces'

interface ButtonTypeProps<T extends FieldValues> {
  name: string
  register: UseFormRegisterReturn<FieldName<T>>
  children: React.ReactNode
  selectedType?: string
}

const ButtonType = <T extends FieldValues>({
  name,
  children,
  register,
  selectedType
}: ButtonTypeProps<T>): JSX.Element => {
  const isSelected = !selectedType || selectedType === name

  return (
    <Radio isSelected={isSelected}>
      <input type="radio" id={name} value={name} {...register} />
      <label htmlFor={name}>{children}</label>
    </Radio>
  )
}

interface FeedbackTypeSelectorProps<T extends FieldValues> {
  register: UseFormRegisterReturn<FieldName<T>>
  selectedType?: string
}

export const FeedbackTypeSelector = <T extends FieldValues>({
  register,
  selectedType
}: FeedbackTypeSelectorProps<T>): JSX.Element => {
  return (
    <Stack spacing={'0.5rem'} alignItems="start">
      <LabelForm>{message('feedback.feedbackType')}</LabelForm>

      <Inline justifyContent="space-between" width="100%" spacing="0.875rem">
        <ButtonType name={EFeedbackType.COMPLIMENT} register={register} selectedType={selectedType}>
          {message('feedback.compliment')}
        </ButtonType>
        <ButtonType name={EFeedbackType.SUGGESTION} register={register} selectedType={selectedType}>
          {message('feedback.suggestion')}
        </ButtonType>
      </Inline>
    </Stack>
  )
}
